<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.seqNo" v-model="pkgPlanForm.seqNo" :error-messages="errors.collect('seqNo')" v-validate="'required|entry|max:128'" data-vv-name="seqNo" :data-vv-as="labels.seqNo"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!newPkgPlan">
            <v-subheader class="queryLabel">{{labels.planNo}}</v-subheader>
            <div class="title">{{pkgPlanForm.planNo}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field :label="labels.planNo" v-model="pkgPlanForm.planNo" :error-messages="errors.collect('planNo')" v-validate="'required|param|max:4'" data-vv-name="planNo" :data-vv-as="labels.planNo"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.planDesc" v-model="pkgPlanForm.planDesc" :error-messages="errors.collect('planDesc')" v-validate="'required|entry|max:128'" data-vv-name="planDesc" :data-vv-as="labels.planDesc"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <cal-picker :label="labels.effDate" v-model="pkgPlanForm.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <cal-picker :label="labels.expDate" v-model="pkgPlanForm.expDate" :error-messages="errors.collect('expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate" :min="pkgPlanForm.effDate"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.noAdultChildDisc" v-model="pkgPlanForm.noAdultChildDisc" :error-messages="errors.collect('noAdultChildDisc')" v-validate="'numeric|max:10'" data-vv-name="noAdultChildDisc" :data-vv-as="labels.schemeDesc"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-num-mask="{negative: true, intScale: 5, decScale: 2}" :label="labels.childDiscPct" v-model="pkgPlanForm.childDiscPct" :error-messages="errors.collect('childDiscPct')" data-vv-name="childDiscPct" :data-vv-as="labels.childDiscPct"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
        {{ newPkgPlan ? 'Save Plan' : 'Update Plan' }}
        <v-icon right>{{newPkgPlan ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
      <v-btn v-if="!newPkgPlan" color="secondary" type="submit" :loading="exportPlanSummaryLoading" @click.prevent="exportPlanSummary">
        {{ 'Export Plan Summary' }}
        <v-icon right>{{'mdi-printer'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme',
        seqNo: 'Sequence*',
        planNo: 'Package Plan No*',
        planDesc: 'Package Plan Description*',
        noAdultChildDisc: 'Min Adults for Child Discount',
        childDiscPct: 'Child Discount Percentage',
        effDate: 'Effective Date*',
        expDate: 'Expired Date'
      },
      pkgPlanForm: {
        scheme: null,
        schemeDesc: null,
        seqNo: null,
        planNo: null,
        planDesc: null,
        noAdultChildDisc: null,
        childDiscPct: null,
        effDate: null,
        expDate: null
      },
      submitting: false,
      newPkgPlan: false,
      exportPlanSummaryLoading: false
    }
  },
  watch: {
    'ids.planNo': function (value) {
      this.doClearForm()
      if (value === 'new') {
        this.newPkgPlan = true
        this.pkgPlanForm.scheme = this.ids.scheme
      } else {
        this.newPkgPlan = false
        if (value !== null) {
          this.doInit()
        }
      }
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    async doInit() {
      this.pkgPlanForm.scheme = this.ids.scheme
      this.pkgPlanForm.plaNo = this.ids.planNo
      if (!this.newPkgPlan) {
        const apiURI = this.schemeMenu.menu.pkgPlan
        if (apiURI) {
          try {
            const expand = {
              scheme: this.ids.scheme,
              planNo: this.ids.planNo
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.pkgPlanForm.scheme = data.pkgPlan.scheme
              this.pkgPlanForm.schemeDesc = data.pkgPlan.schemeDesc
              this.pkgPlanForm.planNo = data.pkgPlan.planNo
              this.pkgPlanForm.planDesc = data.pkgPlan.planDesc
              this.pkgPlanForm.schemeType = data.pkgPlan.schemeType
              this.pkgPlanForm.noAdultChildDisc = data.pkgPlan.noAdultChildDisc
              this.pkgPlanForm.childDiscPct = formatDisplayNumber(data.pkgPlan.childDiscPct)
              this.pkgPlanForm.effDate = data.pkgPlan.effDate
              this.pkgPlanForm.expDate = data.pkgPlan.expDate
              this.pkgPlanForm.seqNo = data.pkgPlan.seqNo
              this.menu = extractMenu(result.data._links)
            } else {
              this.errorMessage('Fail to load Data from server. Please try to refresh page')
            }
          } catch (error) {
            const { data } = error.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('Invalid API URL - Package Plan Form')
        }
      }
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newPkgPlan) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.schemeMenu.menu.pkgPlanCreate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.pkgPlanForm.scheme,
            planNo: this.pkgPlanForm.planNo,
            planDesc: this.pkgPlanForm.planDesc,
            schemeType: this.pkgPlanForm.schemeType,
            noAdultChildDisc: this.pkgPlanForm.noAdultChildDisc,
            childDiscPct: removeFormatNumber(this.pkgPlanForm.childDiscPct),
            effDate: this.pkgPlanForm.effDate,
            expDate: this.pkgPlanForm.expDate,
            seqNo: this.pkgPlanForm.seqNo
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab')
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL - Package Plan Create')
      }
    },
    async doUpdate() {
      const apiURI = this.menu.pkgPlanUpdate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.pkgPlanForm.scheme,
            planNo: this.pkgPlanForm.planNo,
            planDesc: this.pkgPlanForm.planDesc,
            schemeType: this.pkgPlanForm.schemeType,
            noAdultChildDisc: this.pkgPlanForm.noAdultChildDisc,
            childDiscPct: removeFormatNumber(this.pkgPlanForm.childDiscPct),
            effDate: this.pkgPlanForm.effDate,
            expDate: this.pkgPlanForm.expDate,
            seqNo: this.pkgPlanForm.seqNo
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
          }
        } catch (error) {
          const { data } = error.message
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL - Package Plan Update')
      }
    },
    async exportPlanSummary() {
      const apiUrl = this.menu.exportPlanSummary
      if (apiUrl) {
        try {
          this.exportPlanSummaryLoading = true
          const passObj = {
            scheme: this.pkgPlanForm.scheme,
            planNo: this.pkgPlanForm.planNo
          }
          await this.$http.post(apiUrl, passObj)
          this.exportPlanSummaryLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.exportPlanSummaryLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.pkgPlanForm.scheme = this.ids.scheme
      this.pkgPlanForm.schemeDesc = null
      this.pkgPlanForm.planNo = null
      this.pkgPlanForm.planDesc = null
      this.pkgPlanForm.schemeType = null
      this.pkgPlanForm.noAdultChildDisc = null
      this.pkgPlanForm.childDiscPct = null
      this.pkgPlanForm.effDate = null
      this.pkgPlanForm.expDate = null
      this.pkgPlanForm.seqNo = null
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    ids: {
      type: Object,
      default() {
        return {
          planNo: null
        }
      }
    }
  }
}
</script>

<style>
</style>
